import React, { createContext, ReactNode, useContext, useState } from "react";

export interface ChatbotContextProps {
  suggestions?: Suggestion[];
  threadId?: null | number | string; // Optional, if needed
  threadTitle?: string;
  setSuggestions?: (suggestions: Suggestion[]) => void;
  setThreadId?: (threadId: null | number | string) => void; // Optional, if needed
  setThreadTitle?: (title: string) => void;
}

export interface Suggestion {
  id: string;
  name: string;
  buttons: {
    id: string;
    title: string;
    action: string;
    category: string;
    enabled: boolean;
    icon: string;
    order: number;
  }[];
  label: string;
  order: number;
}

const ChatbotContext = createContext<ChatbotContextProps>(
  {} as ChatbotContextProps
);

interface ChatbotProviderProps {
  children: ReactNode;
}

export const ChatbotProvider: React.FC<ChatbotProviderProps> = ({
  children,
}) => {
  const [threadId, setThreadId] = useState<null | number | string>(null);
  const [threadTitle, setThreadTitle] = useState<string>("");
  const [suggestions, setSuggestions] = useState<Suggestion[]>([]);

  const contextValue: ChatbotContextProps = {
    setSuggestions,
    setThreadId,
    setThreadTitle,
    suggestions,
    threadId,
    threadTitle,
  };

  return (
    <ChatbotContext.Provider value={contextValue}>
      {children}
    </ChatbotContext.Provider>
  );
};

export const useChatbot = (): ChatbotContextProps => {
  const context = useContext(ChatbotContext);
  if (context === undefined) {
    throw new Error("useChatbot must be used within a ChatbotProvider");
  }
  return context;
};

export default ChatbotContext;
